/**
 * @generated SignedSource<<2ca1827aa4614470ebcc1f78da645df8>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
export type JiraProjectAccessLevelType = "FREE" | "LIMITED" | "OPEN" | "PRIVATE" | "%future added value";
export type JiraProjectStyle = "COMPANY_MANAGED_PROJECT" | "TEAM_MANAGED_PROJECT" | "%future added value";
export type JiraProjectType = "BUSINESS" | "CUSTOMER_SERVICE" | "PRODUCT_DISCOVERY" | "SERVICE_DESK" | "SOFTWARE" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type ExtraComponentsFar$data = {
  readonly accessLevel?: JiraProjectAccessLevelType | null | undefined;
  readonly avatar: {
    readonly large: string | null | undefined;
  } | null | undefined;
  readonly canEditProjectConfig: {
    readonly canPerform: boolean;
  } | null | undefined;
  readonly key: string;
  readonly name: string;
  readonly projectId: string | null | undefined;
  readonly projectStyle: JiraProjectStyle | null | undefined;
  readonly projectType: JiraProjectType | null | undefined;
  readonly " $fragmentType": "ExtraComponentsFar";
};
export type ExtraComponentsFar$key = {
  readonly " $data"?: ExtraComponentsFar$data;
  readonly " $fragmentSpreads": FragmentRefs<"ExtraComponentsFar">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraisfetchaccesslevelforsplitsharebuttonenabledrelayprovider"
    }
  ],
  "kind": "Fragment",
  "name": "ExtraComponentsFar",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "key"
    },
    {
      "kind": "ScalarField",
      "name": "name"
    },
    {
      "kind": "ScalarField",
      "name": "projectId"
    },
    {
      "kind": "ScalarField",
      "name": "projectStyle"
    },
    {
      "kind": "ScalarField",
      "name": "projectType"
    },
    {
      "concreteType": "JiraAvatar",
      "kind": "LinkedField",
      "name": "avatar",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "large"
        }
      ]
    },
    {
      "alias": "canEditProjectConfig",
      "args": [
        {
          "kind": "Literal",
          "name": "type",
          "value": "EDIT_PROJECT_CONFIG"
        }
      ],
      "concreteType": "JiraProjectAction",
      "kind": "LinkedField",
      "name": "action",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "canPerform"
        }
      ],
      "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
    },
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraisfetchaccesslevelforsplitsharebuttonenabledrelayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "accessLevel"
        }
      ]
    }
  ],
  "type": "JiraProject"
};

(node as any).hash = "900168e7574c4a32db70ef5a02e68657";

export default node;
